import { useNavigate } from 'react-router-dom';
import { TabBar } from '@/components/kit';
import { useNarrowViewport } from '@/layouts/shellChrome';

/**
 * The phone's "Expenses | People we pay | P&L" strip — the three MONEY OUT
 * screens read as one place on a phone, where the desk has a sidebar for it.
 */
type Door = 'expenses' | 'people' | 'pnl';

export function PhoneTabs({ active }: { active: Door }) {
  const go = useNavigate();
  const narrow = useNarrowViewport();
  if (!narrow) return null;
  return (
    <TabBar
      label="Money out"
      items={[
        { key: 'expenses' as const, label: 'Expenses' },
        { key: 'people' as const, label: 'People we pay' },
        { key: 'pnl' as const, label: 'P&L' },
      ]}
      active={active}
      onSelect={(k) => go(`/accountant/${k}`)}
    />
  );
}
